export default "__VITE_ASSET__B83MFCcG__"